import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Spinner, Table, Button } from "react-bootstrap";
import "./NSDLDemo.css";
import * as ReactBootStrap from "react-bootstrap";

const expectedKeys = {
    "name": "applicant_name",
    "dob": "date_of_birth",
    "gender": "gender",
    "nationality": "nationality",
    "address1": "address.line1",
    "address2": "address.line2",
    "address3": "address.line3",
    "city": "address.city",
    "state": "address.state",
    "pincode": "address.pincode",
    "mobileNo": "mobile_no",
    "emailId": "email_id",
    "panNo": "pan_number"
};


export default function NDSLDemo() {
    const [jsonFileData, setJsonFileData] = useState(null);
    const [apiResponse, setApiResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isApiResponseCollapsed, setIsApiResponseCollapsed] = useState(true);
    const [expandedPaths, setExpandedPaths] = useState({})
    const [metadataPopup, setMetadataPopup] = useState(false)
    // Handle JSON Upload (First Upload)

    const handleOpen = () => {
        setMetadataPopup(!metadataPopup)
    }

    const handleJsonUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== "application/json") {
            alert("Please select a valid JSON file.");
            return;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const parsedJson = JSON.parse(event.target.result);
                setJsonFileData(parsedJson);
                console.log("Uploaded JSON Data:", parsedJson);
            } catch (error) {
                alert("Invalid JSON file format.");
            }
        };
        reader.readAsText(file);
    };

    // Handle PDF Upload (Second Upload, triggers API)
    const handleFileChange = async (e) => {
        if (!jsonFileData) {
            alert("Please upload the JSON file first.");
            return;
        }

        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== "application/pdf") {
            alert("Please select a valid PDF file.");
            return;
        }

        try {
            setLoading(true);
            setApiResponse(null);

            // 1) Generate a random ID
            const randomId = uuidv4();

            // 2) Fetch presigned URL
            const presignResponse = await fetch(
                `https://4ctqbasweb.execute-api.ap-south-1.amazonaws.com/default/presign_url_generate?unique_id=${randomId}&filetype=pdf`,
                { method: "POST" }
            );
            const presignData = await presignResponse.json();

            if (!presignData.URL) {
                alert("Failed to fetch upload URL");
                setLoading(false);
                return;
            }

            // 3) Upload PDF
            const uploadUrl = presignData.URL;
            const uploadResponse = await fetch(uploadUrl, {
                method: "PUT",
                body: file,
                headers: { "Content-Type": "application/pdf" },
            });
            if (!uploadResponse.ok) {
                alert("Upload failed.");
                setLoading(false);
                return;
            }
            console.log("File uploaded successfully");

            // 4) Call next API with that random ID
            const finalResponse = await fetch(
                `https://711bu2kxe7.execute-api.ap-south-1.amazonaws.com/default/cdsl_kra_api?file_key=${randomId}`,
                {
                    method: "POST",
                    headers: {
                        "x-api-key": "lxitg36TQn5EkrPL5OOCW5TfRLiIRaUU7swWDXnG",
                    },
                }
            );
            const finalData = await finalResponse.json();
            setApiResponse(finalData);
            console.log("Post-upload API Response:", finalData);
        } catch (error) {
            console.error("Error during file upload or API call:", error);
            alert("Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, key) => {
            if (acc && key in acc) {
                return acc[key] !== undefined && acc[key] !== null ? acc[key] : "N/A";
            }
            return "N/A";
        }, obj);
    };

    // Compare API Response with Uploaded JSON
    // const compareData = () => {
    //     if (!apiResponse || !jsonFileData) return null;

    //     console.log("🔍 JSON File Keys:", Object.keys(jsonFileData)); // ✅ Log JSON keys for debugging
    //     console.log("🔍 API Response Keys:", Object.keys(apiResponse)); // ✅ Log API keys for debugging

    //     return Object.keys(expectedKeys).map((jsonKey) => {
    //         let apiKey = expectedKeys[jsonKey];

    //         // ✅ Fetch values safely
    //         let apiValue = getNestedValue(apiResponse, apiKey);
    //         let jsonValue = jsonFileData[jsonKey] || "N/A"; // Ensures value from JSON is always fetched

    //         console.log(`🛠 Comparing: ${jsonKey} -> JSON: ${jsonValue}, API: ${apiValue}`); // ✅ Debugging logs

    //         // ✅ Convert both values to lowercase, trim spaces for accurate comparison
    //         let isMatched =
    //             apiValue.toString().trim().toLowerCase() === jsonValue.toString().trim().toLowerCase();

    //         return (
    //             <tr key={jsonKey} className={isMatched ? "table-success" : "table-danger"}>
    //                 <td>{jsonKey.toUpperCase()}</td>
    //                 <td>{jsonValue.toUpperCase()}</td>
    //                 <td>{apiValue.toUpperCase()}</td>
    //                 <td>
    //                     {isMatched ? (
    //                         <span className="text-success fw-bold">✅ Matched</span>
    //                     ) : (
    //                         <span className="text-danger fw-bold">❌ Not Matched</span>
    //                     )}
    //                 </td>
    //             </tr>
    //         );
    //     });
    // };

    const compareData = () => {
        if (!apiResponse || !jsonFileData) return null;

        console.log("🔍 JSON File Keys:", Object.keys(jsonFileData)); // ✅ Log JSON keys for debugging
        console.log("🔍 API Response Keys:", Object.keys(apiResponse)); // ✅ Log API keys for debugging

        return Object.keys(expectedKeys)
            .filter((jsonKey) => !['address1', 'address2', 'address3'].includes(jsonKey)) // Exclude address1, address2, address3
            .map((jsonKey) => {
                let apiKey = expectedKeys[jsonKey];

                // ✅ Fetch values safely
                let apiValue = getNestedValue(apiResponse, apiKey);
                let jsonValue = jsonFileData[jsonKey] || "N/A"; // Ensures value from JSON is always fetched

                // Format mobile_no to remove country code and non-numeric characters
                if (jsonKey === 'mobileNo' && typeof apiValue === 'string') {
                    apiValue = apiValue.replace(/^\+91\s*-\s*/, '').replace(/\D/g, '');
                }

                console.log(`🛠 Comparing: ${jsonKey} -> JSON: ${jsonValue}, API: ${apiValue}`); // ✅ Debugging logs

                // ✅ Convert both values to lowercase, trim spaces for accurate comparison
                let isMatched =
                    apiValue.toString().trim().toLowerCase() === jsonValue.toString().trim().toLowerCase();

                return (
                    <tr key={jsonKey} className={isMatched ? "table-success" : "table-danger"}>
                        <td>{jsonKey.toUpperCase()}</td>
                        <td>{jsonValue.toUpperCase()}</td>
                        <td>{apiValue.toUpperCase()}</td>
                        <td>
                            {isMatched ? (
                                <span className="text-success fw-bold">✅ Matched</span>
                            ) : (
                                <span className="text-danger fw-bold">❌ Not Matched</span>
                            )}
                        </td>
                    </tr>
                );
            });
    };

    // Toggle expanded/collapsed state for a given path
    const toggleExpand = (path) => {
        setExpandedPaths((prev) => ({
            ...prev,
            [path]: !prev[path],
        }));
    };

    /**
     * MAIN RENDER FUNCTION:
     * Decides if data is an array, object, or leaf and renders accordingly
     */
    const renderData = (data, parentKey = "") => {
        if (Array.isArray(data)) {
            // It's an array
            const isExpanded = expandedPaths[parentKey] || false;
            return (
                <div className="ms-3">
                    {parentKey && (
                        <div
                            className="d-flex align-items-center mb-1 fw-bold"
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleExpand(parentKey)}
                        >
                            <span className="me-1">{isExpanded ? "▼" : "▶"}</span>
                            <span>
                                {parentKey} [{data.length}]
                            </span>
                        </div>
                    )}
                    {(!parentKey || isExpanded) && (
                        <ul className="list-unstyled ms-4">
                            {data.map((item, idx) => {
                                const newPath = parentKey
                                    ? `${parentKey}[${idx}]`
                                    : String(idx);
                                return (
                                    <li key={newPath} className="mb-2">
                                        {renderData(item, newPath)}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            );
        } else if (data && typeof data === "object") {
            // It's an object
            const isExpanded = expandedPaths[parentKey] || false;
            const keys = Object.keys(data);

            return (
                <div className="ms-2">
                    {/* Collapsible header if parentKey is present */}
                    {parentKey && (
                        <div
                            className="d-flex align-items-center mb-1 fw-bold"
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleExpand(parentKey)}
                        >
                            <span className="me-1">{isExpanded ? "▼" : "▶"}</span>
                            <span>{parentKey}</span>
                        </div>
                    )}

                    {(!parentKey || isExpanded) && (
                        // TABLE for all key/value pairs in the object
                        <table className="table table-bordered table-striped table-sm ms-3">
                            <tbody>
                                {keys.map((key) => {
                                    const val = data[key];
                                    const newPath = parentKey
                                        ? `${parentKey}.${key}`
                                        : key;

                                    // If child is object/array, render nested inside table cell
                                    if (val && typeof val === "object") {
                                        return (
                                            <tr key={newPath}>
                                                <th style={{ width: "30%" }}>{key}</th>
                                                <td>{renderData(val, newPath)}</td>
                                            </tr>
                                        );
                                    } else {
                                        // Leaf field
                                        return (
                                            <tr key={newPath}>
                                                <th>{key}</th>
                                                <td>{renderLeafValue(val, newPath)}</td>
                                            </tr>
                                        );
                                    }
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            );
        } else {
            // It's a leaf (string/number/boolean/etc.)
            return <>{renderLeafValue(data, parentKey)}</>;
        }
    };

    /**
     * RENDER LEAF VALUE:
     * If a string looks like base64 for an image, show <img>, else text
     */
    const renderLeafValue = (value, path) => {
        if (typeof value === "string") {
            const trimmed = value.trim();
            const isJPEG = trimmed.startsWith("/9j/");
            const isPNG = trimmed.startsWith("iVBOR");

            if (isJPEG || isPNG) {
                const prefix = isJPEG
                    ? "data:image/jpeg;base64,"
                    : "data:image/png;base64,";
                const dataURI = prefix + trimmed;
                return (
                    <img
                        src={dataURI}
                        alt={path}
                        style={{ maxWidth: "200px" }}
                        className="border ms-2"
                    />
                );
            }
            // Otherwise, plain text
            return <span className="text-muted">{value}</span>;
        }
        // For numbers, booleans, null, etc.
        return <span className="text-muted">{JSON.stringify(value)}</span>;
    };

    return (
        <div className="container my-4">
            <div className="row justify-content-center mb-3">
                <div className="col-md-4 text-center">
                    <h5>Client json</h5>
                    <input
                        type="file"
                        className="form-control"
                        accept=".json"
                        onChange={handleJsonUpload}
                    />
                    {jsonFileData && <p className="text-success mt-2">✅ JSON Uploaded Successfully</p>}
                </div>
                <div className="col-md-4 text-center">
                    <h5>AOF</h5>
                    <input
                        type="file"
                        className="form-control"
                        accept=".pdf"
                        onChange={handleFileChange}
                        disabled={!jsonFileData} // Disable until JSON is uploaded
                    />
                    {apiResponse && <p className="text-success mt-2">✅ JSON Uploaded Successfully</p>}
                </div>
            </div>

            <div className="row justify-content-center mb-3">
                <div className="col-md-4 text-center">
                    {loading && <Spinner animation="border" />}
                    {/* {!jsonFileData || !apiResponse && <p className="text-danger mt-2">⚠ Upload both File</p>} */}
                </div>
            </div>

            {apiResponse && (
                <div className="mt-4">
                    <div className="d-flex justify-content-center">
                        <Button
                            variant="primary"
                            onClick={() => setIsApiResponseCollapsed(!isApiResponseCollapsed)}
                            aria-controls="api-response-collapse"
                            aria-expanded={!isApiResponseCollapsed}

                        >
                            {isApiResponseCollapsed ? "Show API Response" : "Hide API Response"}
                        </Button>
                    </div>
                    <div id="api-response-collapse" className={`mt-3 ${isApiResponseCollapsed ? "collapse" : ""}`}>
                        <h4 className="mb-3">API Response (Table View)</h4>
                        {renderData(apiResponse)}
                    </div>
                    <div style={{ width: '80%', margin: ' auto', }}> <h4>💠 Compare Fields Data</h4></div>

                    <div style={{ width: '80%', margin: ' auto', boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: '5px', marginTop: '1rem', cursor: 'pointer' }} onClick={handleOpen}>

                        <div style={{ display: 'flex', border: '1px solid rgb(211, 211, 211)' }}>
                            <div className="d-flex align-items-center justify-content-center" style={{ width: '5%', height: '100%', padding: 3 }}>
                                <h4 style={{ margin: 0 }} >{metadataPopup ? '⬇️' : '➡️'}</h4>
                            </div>
                            <div className="d-flex " style={{ width: '95%', height: '100%', marginTop: '0.3rem', padding: 3 }}>
                                <h5 style={{ margin: 0, }}>Meta Data Vs AOF</h5>
                            </div>
                        </div>
                        {
                            metadataPopup &&
                            <div style={{ width: '100%', padding: '5px' }}>
                                <Table striped bordered hover>
                                    <thead>
                                        <tr style={{ backgroundColor: '#4a4e69', color: 'wheat' }}>
                                            <th>Field Name</th>
                                            <th>Client Meta Data</th>
                                            <th>AOF Data</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>{compareData()}</tbody>
                                </Table>
                            </div>
                        }
                    </div>
                    <SpecificFieldsTable data={apiResponse} />
                </div>
            )}
        </div>
    );
}


const specificFields = [
    'esign-coordinates',
    'liveliness_response',
    'facematch_confidence',
    'panocr_response',
    'aadhaar_response',
    'signature_vaidate_response',
    'location_details'
];

const fieldDisplayNames = {
    'esign-coordinates': 'Esign Co-ordinates',
    'liveliness_response': 'Liveliness',
    'facematch_confidence': 'Face Match',
    'panocr_response': 'Pan OCR Response',
    'aadhaar_response': 'Aadhaar Response',
    'signature_vaidate_response': 'Signature Response',
    'location_details': 'Geo-tagging'
};

const keyMapping = {
    'aadhaar': 'selfy to aadhaar',
    'pan': 'selfy to pan'
};

const SpecificFieldsTable = ({ data }) => {
    const [expandedPaths, setExpandedPaths] = useState({});

    const toggleExpand = (path) => {
        setExpandedPaths((prev) => ({
            ...prev,
            [path]: !prev[path],
        }));
    };

    const renderLeafValue = (value, path) => {
        if (typeof value === "string") {
            const trimmed = value.trim();
            const isJPEG = trimmed.startsWith("/9j/");
            const isPNG = trimmed.startsWith("iVBOR");

            if (isJPEG || isPNG) {
                const prefix = isJPEG
                    ? "data:image/jpeg;base64,"
                    : "data:image/png;base64,";
                const dataURI = prefix + trimmed;
                return (
                    <img
                        src={dataURI}
                        alt={path}
                        style={{ maxWidth: "200px" }}
                        className="border ms-2"
                    />
                );
            }
            // Otherwise, plain text
            return <span className="text-muted">{value}</span>;
        }
        // For numbers, booleans, null, etc.
        return <span className="text-muted">{JSON.stringify(value)}</span>;
    };

    const renderData = (data, parentKey = "") => {
        if (Array.isArray(data)) {
            const isExpanded = expandedPaths[parentKey] || false;
            return (
                <div className="ms-3">
                    {parentKey && (
                        <div
                            className="d-flex align-items-center mb-1 fw-bold"
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleExpand(parentKey)}
                        >
                            <span className="me-1">{isExpanded ? "▼" : "▶"}</span>
                            <span>
                                {fieldDisplayNames[parentKey] || parentKey} [{data.length}]
                            </span>
                        </div>
                    )}
                    {(!parentKey || isExpanded) && (
                        <ul className="list-unstyled ms-4">
                            {data.map((item, idx) => {
                                const newPath = parentKey
                                    ? `${parentKey}[${idx}]`
                                    : String(idx);
                                return (
                                    <li key={newPath} className="mb-2">
                                        {renderData(item, newPath)}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            );
        } else if (data && typeof data === "object") {
            const isExpanded = expandedPaths[parentKey] || false;
            const keys = Object.keys(data);

            return (
                <div style={{ margin: 'auto', boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: '5px', marginTop: '1rem', cursor: 'pointer', padding: 5 }}>
                    {parentKey && (
                        <div
                            className="d-flex align-items-center mb-1 fw-bold"
                            onClick={() => toggleExpand(parentKey)}
                        >
                            <span className="me-1">{isExpanded ? '⬇️' : '➡️'}</span>
                            <span>{fieldDisplayNames[parentKey] || parentKey}</span>
                        </div>
                    )}

                    {(!parentKey || isExpanded) && (
                        <table className="table table-bordered table-striped table-sm">
                            <tbody>
                                {keys.map((key) => {
                                    const val = data[key];
                                    const newPath = parentKey
                                        ? `${parentKey}.${key}`
                                        : key;

                                    const displayKey = keyMapping[key] || key;

                                    if (val && typeof val === "object") {
                                        return (
                                            <tr key={newPath}>
                                                <th style={{ width: "30%" }}>{displayKey}</th>
                                                <td>{renderData(val, newPath)}</td>
                                            </tr>
                                        );
                                    } else {
                                        return (
                                            <tr key={newPath}>
                                                <th>{displayKey}</th>
                                                <td>{renderLeafValue(val, newPath)}</td>
                                            </tr>
                                        );
                                    }
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            );
        } else {
            return <>{renderLeafValue(data, parentKey)}</>;
        }
    };

    return (
        <div className="table-container">
            <h4>📊 Extracted Data from AOF</h4>
            {specificFields.map((field) => (
                <div key={field}>
                    {/* <h5>{fieldDisplayNames[field]}</h5> */}
                    {renderData(data[field], field)}
                </div>
            ))}
        </div>
    );
};

